import React from 'react'
import {useIntl} from 'react-intl'
import {Button} from '../../../../_gori/partials/widgets'
import {BatchesConfig} from '../core/_const'
import {KTSVG} from '../../../../_gori/helpers'

type Props = {
  onFileSelect: (file: File) => void
}

const BatchesEmptyState: React.FC<Props> = ({onFileSelect}) => {
  const intl = useIntl()

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (file) {
      onFileSelect(file)
    }
    e.target.value = ''
  }

  return (
    <div className='dropzone bg-light-primary border-primary border-2 batches-empty-state mb-8'>
      <div>
        <div className='text-center'>
          <div className='fs-4 fw-bold text-dark mb-1'>
            {intl.formatMessage({id: 'DRAG_AND_DROP_HERE_OR'})}{' '}
            <span className='text-primary'>{intl.formatMessage({id: 'BROWSE_FILES'})}</span>
          </div>
          <Button
            className='btn btn-advanced-primary mt-4'
            label={intl.formatMessage({id: 'UPLOAD_CSV'})}
            icon={<KTSVG path='/media/gori/orders/upload_csv.svg' className='me-2 svg-icon-2' />}
          />
        </div>
        <input
          type='file'
          onChange={handleFileChange}
          className='dropzone__upload cursor-pointer'
          accept={BatchesConfig.SUPPORTED_FORMATS.join(',')}
        />
      </div>
    </div>
  )
}

export {BatchesEmptyState}
